export const NotFound = () => {
    return (
        <div className="w-full h-screen flex flex-col items-center justify-center bg-[#0F172B] text-white">
            <h1 className="text-6xl font-bold mb-4">404</h1>
            <p className="text-lg text-[#90A1B9] mb-6">
                페이지를 찾을 수 없습니다
            </p>
        </div>
    );
}